export default {
    en: {
        contactIntroLead: 'Whether you want to ask a question, get help, or report a problem – we’re here to talk.',
        contactIntroInstructions: 'Please complete the form below or email',
        contactIntroClosing: ' and we\'ll get back to you.',
        contactSubjectLabel: 'Subject',
        contactMessageLabel: 'Message',
        contactSend: 'Send',
        contactSubjectTechnicalIssue: 'Technical issue',
        contactSubjectHelpSupport: 'Help & support',
        contactSubjectMembership: 'Your membership',
        contactSubjectDataSecurity: 'Data security',
        contactSubjectRewardsPayments: 'Rewards and payments',
        contactSubjectGeneralEnquiry: 'General enquiry',
        contactSubjectOther: 'Other',
        contactSubmitError: 'Error submitting message',
        contactSubmitSuccess: 'Your message has been successfully sent',
    },
    in: {
        contactIntroLead: 'Apakah Anda ingin mengajukan pertanyaan, mendapatkan bantuan, atau melaporkan masalah – kami siap membantu.',
        contactIntroInstructions: 'Silakan lengkapi formulir di bawah ini atau kirim email ke',
        contactIntroClosing: ' dan kami akan menghubungi Anda kembali.',
        contactSubjectLabel: 'Subjek',
        contactMessageLabel: 'Pesan',
        contactSend: 'Kirim',
        contactSubjectTechnicalIssue: 'Masalah teknis',
        contactSubjectHelpSupport: 'Bantuan & dukungan',
        contactSubjectMembership: 'Keanggotaan Anda',
        contactSubjectDataSecurity: 'Keamanan data',
        contactSubjectRewardsPayments: 'Hadiah dan pembayaran',
        contactSubjectGeneralEnquiry: 'Pertanyaan umum',
        contactSubjectOther: 'Lainnya',
        contactSubmitError: 'Gagal mengirim pesan',
        contactSubmitSuccess: 'Pesan Anda berhasil dikirim',
    },
    zh: {
        contactIntroLead: '无论您是想提问、寻求帮助还是报告问题，我们都乐意与您沟通。',
        contactIntroInstructions: '请填写下面的表格或发送电子邮件至',
        contactIntroClosing: '，我们会尽快回复您。',
        contactSubjectLabel: '主题',
        contactMessageLabel: '消息',
        contactSend: '发送',
        contactSubjectTechnicalIssue: '技术问题',
        contactSubjectHelpSupport: '帮助与支持',
        contactSubjectMembership: '您的会员资格',
        contactSubjectDataSecurity: '数据安全',
        contactSubjectRewardsPayments: '奖励与付款',
        contactSubjectGeneralEnquiry: '一般咨询',
        contactSubjectOther: '其他',
        contactSubmitError: '提交消息时出错',
        contactSubmitSuccess: '您的消息已成功发送',
    },
    nl: {
        contactIntroLead: 'Of u nu een vraag wilt stellen, hulp nodig heeft of een probleem wilt melden – we staan voor u klaar.',
        contactIntroInstructions: 'Vul het onderstaande formulier in of stuur een e-mail naar',
        contactIntroClosing: ' en we nemen contact met u op.',
        contactSubjectLabel: 'Onderwerp',
        contactMessageLabel: 'Bericht',
        contactSend: 'Verzenden',
        contactSubjectTechnicalIssue: 'Technisch probleem',
        contactSubjectHelpSupport: 'Hulp & ondersteuning',
        contactSubjectMembership: 'Uw lidmaatschap',
        contactSubjectDataSecurity: 'Gegevensbeveiliging',
        contactSubjectRewardsPayments: 'Beloningen en betalingen',
        contactSubjectGeneralEnquiry: 'Algemene vraag',
        contactSubjectOther: 'Overig',
        contactSubmitError: 'Fout bij het verzenden van het bericht',
        contactSubmitSuccess: 'Uw bericht is succesvol verzonden',
    },
    fi: {
        contactIntroLead: 'Haluatpa esittää kysymyksen, saada apua tai ilmoittaa ongelmasta – olemme täällä sinua varten.',
        contactIntroInstructions: 'Täytä alla oleva lomake tai lähetä sähköpostia osoitteeseen',
        contactIntroClosing: ' ja palaamme asiaan.',
        contactSubjectLabel: 'Aihe',
        contactMessageLabel: 'Viesti',
        contactSend: 'Lähetä',
        contactSubjectTechnicalIssue: 'Tekninen ongelma',
        contactSubjectHelpSupport: 'Apu ja tuki',
        contactSubjectMembership: 'Jäsenyytesi',
        contactSubjectDataSecurity: 'Tietoturva',
        contactSubjectRewardsPayments: 'Palkinnot ja maksut',
        contactSubjectGeneralEnquiry: 'Yleinen tiedustelu',
        contactSubjectOther: 'Muu',
        contactSubmitError: 'Virhe viestin lähetyksessä',
        contactSubmitSuccess: 'Viestisi on lähetetty onnistuneesti',
    },
    fr: {
        contactIntroLead: 'Que vous souhaitiez poser une question, obtenir de l\'aide ou signaler un problème, nous sommes là pour vous.',
        contactIntroInstructions: 'Veuillez remplir le formulaire ci-dessous ou envoyer un e-mail à',
        contactIntroClosing: ' et nous vous répondrons.',
        contactSubjectLabel: 'Objet',
        contactMessageLabel: 'Message',
        contactSend: 'Envoyer',
        contactSubjectTechnicalIssue: 'Problème technique',
        contactSubjectHelpSupport: 'Aide et assistance',
        contactSubjectMembership: 'Votre adhésion',
        contactSubjectDataSecurity: 'Sécurité des données',
        contactSubjectRewardsPayments: 'Récompenses et paiements',
        contactSubjectGeneralEnquiry: 'Demande générale',
        contactSubjectOther: 'Autre',
        contactSubmitError: 'Erreur lors de l\'envoi du message',
        contactSubmitSuccess: 'Votre message a été envoyé avec succès',
    },
    de: {
        contactIntroLead: 'Ob Sie eine Frage stellen, Hilfe benötigen oder ein Problem melden möchten – wir sind für Sie da.',
        contactIntroInstructions: 'Bitte füllen Sie das untenstehende Formular aus oder senden Sie eine E-Mail an',
        contactIntroClosing: ' und wir melden uns bei Ihnen.',
        contactSubjectLabel: 'Betreff',
        contactMessageLabel: 'Nachricht',
        contactSend: 'Senden',
        contactSubjectTechnicalIssue: 'Technisches Problem',
        contactSubjectHelpSupport: 'Hilfe & Support',
        contactSubjectMembership: 'Ihre Mitgliedschaft',
        contactSubjectDataSecurity: 'Datensicherheit',
        contactSubjectRewardsPayments: 'Prämien und Zahlungen',
        contactSubjectGeneralEnquiry: 'Allgemeine Anfrage',
        contactSubjectOther: 'Sonstiges',
        contactSubmitError: 'Fehler beim Senden der Nachricht',
        contactSubmitSuccess: 'Ihre Nachricht wurde erfolgreich gesendet',
    },
    hi: {
        contactIntroLead: 'चाहे आप प्रश्न पूछना चाहते हों, सहायता लेना चाहते हों या कोई समस्या रिपोर्ट करना चाहते हों – हम बात करने के लिए यहाँ हैं।',
        contactIntroInstructions: 'कृपया नीचे दिया गया फ़ॉर्म भरें या ईमेल करें',
        contactIntroClosing: ' और हम आपसे संपर्क करेंगे।',
        contactSubjectLabel: 'विषय',
        contactMessageLabel: 'संदेश',
        contactSend: 'भेजें',
        contactSubjectTechnicalIssue: 'तकनीकी समस्या',
        contactSubjectHelpSupport: 'सहायता और समर्थन',
        contactSubjectMembership: 'आपकी सदस्यता',
        contactSubjectDataSecurity: 'डेटा सुरक्षा',
        contactSubjectRewardsPayments: 'पुरस्कार और भुगतान',
        contactSubjectGeneralEnquiry: 'सामान्य पूछताछ',
        contactSubjectOther: 'अन्य',
        contactSubmitError: 'संदेश भेजने में त्रुटि',
        contactSubmitSuccess: 'आपका संदेश सफलतापूर्वक भेजा गया',
    },
    it: {
        contactIntroLead: 'Che tu voglia fare una domanda, ricevere aiuto o segnalare un problema, siamo qui per te.',
        contactIntroInstructions: 'Compila il modulo qui sotto o invia un\'e-mail a',
        contactIntroClosing: ' e ti risponderemo.',
        contactSubjectLabel: 'Oggetto',
        contactMessageLabel: 'Messaggio',
        contactSend: 'Invia',
        contactSubjectTechnicalIssue: 'Problema tecnico',
        contactSubjectHelpSupport: 'Aiuto e supporto',
        contactSubjectMembership: 'La tua iscrizione',
        contactSubjectDataSecurity: 'Sicurezza dei dati',
        contactSubjectRewardsPayments: 'Premi e pagamenti',
        contactSubjectGeneralEnquiry: 'Richiesta generale',
        contactSubjectOther: 'Altro',
        contactSubmitError: 'Errore durante l\'invio del messaggio',
        contactSubmitSuccess: 'Il tuo messaggio è stato inviato con successo',
    },
    ja: {
        contactIntroLead: 'ご質問、サポート、問題の報告など、お気軽にご連絡ください。',
        contactIntroInstructions: '以下のフォームにご記入いただくか、メールで',
        contactIntroClosing: ' までご連絡ください。折り返しご連絡いたします。',
        contactSubjectLabel: '件名',
        contactMessageLabel: 'メッセージ',
        contactSend: '送信',
        contactSubjectTechnicalIssue: '技術的な問題',
        contactSubjectHelpSupport: 'ヘルプとサポート',
        contactSubjectMembership: 'メンバーシップ',
        contactSubjectDataSecurity: 'データセキュリティ',
        contactSubjectRewardsPayments: '報酬と支払い',
        contactSubjectGeneralEnquiry: '一般的なお問い合わせ',
        contactSubjectOther: 'その他',
        contactSubmitError: 'メッセージの送信中にエラーが発生しました',
        contactSubmitSuccess: 'メッセージが正常に送信されました',
    },
    ko: {
        contactIntroLead: '질문, 도움 요청, 문제 신고 등 무엇이든 편하게 문의해 주세요.',
        contactIntroInstructions: '아래 양식을 작성하거나 다음 이메일로 문의해 주세요:',
        contactIntroClosing: ' 답변 드리겠습니다.',
        contactSubjectLabel: '제목',
        contactMessageLabel: '메시지',
        contactSend: '보내기',
        contactSubjectTechnicalIssue: '기술 문제',
        contactSubjectHelpSupport: '도움말 및 지원',
        contactSubjectMembership: '회원 정보',
        contactSubjectDataSecurity: '데이터 보안',
        contactSubjectRewardsPayments: '보상 및 결제',
        contactSubjectGeneralEnquiry: '일반 문의',
        contactSubjectOther: '기타',
        contactSubmitError: '메시지 전송 중 오류가 발생했습니다',
        contactSubmitSuccess: '메시지가 성공적으로 전송되었습니다',
    },
    pl: {
        contactIntroLead: 'Niezależnie od tego, czy chcesz zadać pytanie, uzyskać pomoc czy zgłosić problem – jesteśmy do dyspozycji.',
        contactIntroInstructions: 'Wypełnij poniższy formularz lub napisz na adres',
        contactIntroClosing: ' – odezwiemy się do Ciebie.',
        contactSubjectLabel: 'Temat',
        contactMessageLabel: 'Wiadomość',
        contactSend: 'Wyślij',
        contactSubjectTechnicalIssue: 'Problem techniczny',
        contactSubjectHelpSupport: 'Pomoc i wsparcie',
        contactSubjectMembership: 'Twoje członkostwo',
        contactSubjectDataSecurity: 'Bezpieczeństwo danych',
        contactSubjectRewardsPayments: 'Nagrody i płatności',
        contactSubjectGeneralEnquiry: 'Ogólne zapytanie',
        contactSubjectOther: 'Inne',
        contactSubmitError: 'Błąd podczas wysyłania wiadomości',
        contactSubmitSuccess: 'Twoja wiadomość została wysłana pomyślnie',
    },
    pt: {
        contactIntroLead: 'Quer fazer uma pergunta, obter ajuda ou reportar um problema – estamos aqui para falar consigo.',
        contactIntroInstructions: 'Preencha o formulário abaixo ou envie um e-mail para',
        contactIntroClosing: ' e entraremos em contacto.',
        contactSubjectLabel: 'Assunto',
        contactMessageLabel: 'Mensagem',
        contactSend: 'Enviar',
        contactSubjectTechnicalIssue: 'Problema técnico',
        contactSubjectHelpSupport: 'Ajuda e suporte',
        contactSubjectMembership: 'A sua adesão',
        contactSubjectDataSecurity: 'Segurança de dados',
        contactSubjectRewardsPayments: 'Recompensas e pagamentos',
        contactSubjectGeneralEnquiry: 'Consulta geral',
        contactSubjectOther: 'Outro',
        contactSubmitError: 'Erro ao enviar mensagem',
        contactSubmitSuccess: 'A sua mensagem foi enviada com sucesso',
    },
    es: {
        contactIntroLead: 'Tanto si quieres hacer una pregunta, obtener ayuda o informar de un problema, estamos aquí para hablar contigo.',
        contactIntroInstructions: 'Completa el formulario a continuación o envía un correo a',
        contactIntroClosing: ' y nos pondremos en contacto contigo.',
        contactSubjectLabel: 'Asunto',
        contactMessageLabel: 'Mensaje',
        contactSend: 'Enviar',
        contactSubjectTechnicalIssue: 'Problema técnico',
        contactSubjectHelpSupport: 'Ayuda y soporte',
        contactSubjectMembership: 'Tu membresía',
        contactSubjectDataSecurity: 'Seguridad de datos',
        contactSubjectRewardsPayments: 'Recompensas y pagos',
        contactSubjectGeneralEnquiry: 'Consulta general',
        contactSubjectOther: 'Otro',
        contactSubmitError: 'Error al enviar el mensaje',
        contactSubmitSuccess: 'Tu mensaje se ha enviado correctamente',
    },
    tr: {
        contactIntroLead: 'Bir soru sormak, yardım almak veya bir sorun bildirmek istiyorsanız – konuşmak için buradayız.',
        contactIntroInstructions: 'Lütfen aşağıdaki formu doldurun veya şu adrese e-posta gönderin:',
        contactIntroClosing: ' size geri döneceğiz.',
        contactSubjectLabel: 'Konu',
        contactMessageLabel: 'Mesaj',
        contactSend: 'Gönder',
        contactSubjectTechnicalIssue: 'Teknik sorun',
        contactSubjectHelpSupport: 'Yardım ve destek',
        contactSubjectMembership: 'Üyeliğiniz',
        contactSubjectDataSecurity: 'Veri güvenliği',
        contactSubjectRewardsPayments: 'Ödüller ve ödemeler',
        contactSubjectGeneralEnquiry: 'Genel soru',
        contactSubjectOther: 'Diğer',
        contactSubmitError: 'Mesaj gönderilirken hata oluştu',
        contactSubmitSuccess: 'Mesajınız başarıyla gönderildi',
    },
    vi: {
        contactIntroLead: 'Dù bạn muốn đặt câu hỏi, nhận trợ giúp hay báo cáo sự cố – chúng tôi luôn sẵn sàng trò chuyện.',
        contactIntroInstructions: 'Vui lòng hoàn thành biểu mẫu bên dưới hoặc gửi email tới',
        contactIntroClosing: ' và chúng tôi sẽ liên hệ lại với bạn.',
        contactSubjectLabel: 'Chủ đề',
        contactMessageLabel: 'Tin nhắn',
        contactSend: 'Gửi',
        contactSubjectTechnicalIssue: 'Sự cố kỹ thuật',
        contactSubjectHelpSupport: 'Trợ giúp & hỗ trợ',
        contactSubjectMembership: 'Tư cách thành viên của bạn',
        contactSubjectDataSecurity: 'Bảo mật dữ liệu',
        contactSubjectRewardsPayments: 'Phần thưởng và thanh toán',
        contactSubjectGeneralEnquiry: 'Yêu cầu chung',
        contactSubjectOther: 'Khác',
        contactSubmitError: 'Lỗi khi gửi tin nhắn',
        contactSubmitSuccess: 'Tin nhắn của bạn đã được gửi thành công',
    },
    ar: {
        contactIntroLead: 'سواء أردت طرح سؤال أو الحصول على مساعدة أو الإبلاغ عن مشكلة — نحن هنا للتحدث معك.',
        contactIntroInstructions: 'يرجى إكمال النموذج أدناه أو مراسلتنا عبر البريد الإلكتروني على',
        contactIntroClosing: ' وسنعاود الاتصال بك.',
        contactSubjectLabel: 'الموضوع',
        contactMessageLabel: 'الرسالة',
        contactSend: 'إرسال',
        contactSubjectTechnicalIssue: 'مشكلة تقنية',
        contactSubjectHelpSupport: 'المساعدة والدعم',
        contactSubjectMembership: 'عضويتك',
        contactSubjectDataSecurity: 'أمن البيانات',
        contactSubjectRewardsPayments: 'المكافآت والمدفوعات',
        contactSubjectGeneralEnquiry: 'استفسار عام',
        contactSubjectOther: 'أخرى',
        contactSubmitError: 'حدث خطأ أثناء إرسال الرسالة',
        contactSubmitSuccess: 'تم إرسال رسالتك بنجاح',
    },
};
